import { combineReducers } from 'redux';
import xmlReducer from './xmlReducer';
import responseReducer from './responseReducer';
import { settingsReducer } from 'travco-services';
import filterReducer from './filterReducer';
import sortingReducer from './sortingReducer';
import paginationReducer from './paginationReducer';
import { pendingTasksReducer } from 'react-redux-spinner';
import { reducer as oidcReducer } from 'redux-oidc';

const rootReducer = combineReducers({
    oidc: oidcReducer,
    xml: xmlReducer,
    response: responseReducer,
    searchFilter: filterReducer,
    searchSort: sortingReducer,
    searchPagination: paginationReducer,
    settings: settingsReducer,
    pendingTasks: pendingTasksReducer
});

export default rootReducer;
